// extracted by mini-css-extract-plugin
export default {"wrapper":"_8HBAtaxPHFb5173Jhmp","offboardBtn":"su11SRG81PqC0mlMBnLs"};